import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-4 sm:pt-8 pb-16 px-4 overflow-hidden bg-brand-base relative" data-id="element-173">
      {/* glows */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-brand-purple/30 rounded-full blur-[120px] pointer-events-none" data-id="element-174"></div>
      <div className="absolute top-2/3 left-1/4 w-[300px] h-[300px] bg-brand-gold/15 rounded-full blur-[100px] pointer-events-none" data-id="element-175"></div>
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[300px] h-[100px] bg-brand-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-176"></div>

      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 sm:px-4 sm:py-2 rounded-full bg-white/5 border border-brand-neon/40 text-brand-neon font-semibold text-xs sm:text-sm mb-3 sm:mb-6 backdrop-blur-sm" style={{
        textShadow: '0 0 12px rgba(213, 128, 255, 0.5)'
      }} data-id="element-178">
          <span data-id="element-179">🌸</span> IMPULSO DIGITAL STORE™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-2 text-white text-[28px] leading-tight" data-id="element-180">
          <span className="block text-brand-neon" style={{
          textShadow: '0 0 20px rgba(213, 128, 255, 0.6)'
        }} data-id="element-181">
            +500 versículos
          </span>
          <span className="block" data-id="element-182">
            todo el sistema para crear tus frasquitos.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-xl sm:text-3xl lg:text-4xl font-extrabold text-brand-neon mb-4 sm:mb-6 leading-tight" style={{
        textShadow: '0 0 18px rgba(213, 128, 255, 0.5)'
      }} data-id="element-183">
          Listo. Desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative w-full max-w-[240px] sm:max-w-md lg:max-w-lg mb-4 sm:mb-6 mt-4" data-id="element-184">
          <div className="absolute inset-0 bg-brand-neon/20 rounded-full blur-3xl scale-90 pointer-events-none" data-id="element-185"></div>
          <img src="https://cdn.magicpatterns.com/uploads/q2NKZ4XsC477sHYuFDKXbw/png.png" alt="Megapack Emprende con Dios" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-186" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="text-gray-200 text-[13px] sm:text-base leading-snug max-w-xl mb-4 sm:mb-6 px-2" data-id="element-187">
          Guías, plantillas y materiales listos para fabricar, presentar y
          compartir tus frasquitos cristianos.
        </motion.p>

        <div className="relative inline-block mb-6 sm:mb-8" data-id="element-188">
          <div className="absolute -inset-4 bg-brand-neon/40 blur-2xl rounded-full -z-10 pointer-events-none" data-id="element-189"></div>
          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={scrollToPricing} className="bg-brand-green text-white font-bold text-base sm:text-lg py-3.5 px-8 sm:py-4 sm:px-10 rounded-xl shadow-[0_8px_30px_rgba(213,128,255,0.4)] hover:shadow-[0_10px_40px_rgba(213,128,255,0.6)] transition-all relative z-10 border border-brand-neon/30" data-id="element-190">
            🌸 QUIERO MI MEGAPACK AHORA
          </motion.button>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-x-3 sm:gap-x-6 text-[11px] sm:text-sm font-medium text-gray-300 mb-8 whitespace-nowrap" data-id="element-191">
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-192">
            <Shield size={14} className="text-brand-neon shrink-0 sm:size-4" data-id="element-193" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-194">
            <Lock size={14} className="text-brand-neon shrink-0 sm:size-4" data-id="element-195" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-196">
            <CreditCard size={14} className="text-brand-neon shrink-0 sm:size-4" data-id="element-197" />{' '}
            Mercado Pago
          </span>
        </div>

        <div className="w-full max-w-md h-px bg-white/10 mb-6" data-id="element-198"></div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-6 w-full max-w-xs sm:max-w-sm py-2" data-id="element-199">
          <div className="flex flex-col items-center text-center" data-id="element-200">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-201">
              +500
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-neon" data-id="element-202">
              emprendedoras ya empezaron
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-203">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-204">
              6
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-neon" data-id="element-205">
              Tomos listos
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-206">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-207">
              6
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-neon" data-id="element-208">
              Bonos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-209">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-210">
              4.9/5
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-neon inline-flex items-center gap-1" data-id="element-211">
              calificación <span aria-hidden data-id="element-212">⭐</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}